// extracted by mini-css-extract-plugin
module.exports = {"page_bg":"Style_page_bg__1FXT0","text":"Style_text__kIwdn","img_row":"Style_img_row__1gPxv"};